/**
 * Created by henian.xu on 2020/4/27.
 *
 */
import { Utils } from 'vmf';
import Api from '@/api';

const {
    GlobalVar,
    hasOwn,
    isObject,
    Valid,
    isArray,
    isDef,
    isString,
    // add
} = Utils;

export const typeComponentMap = {
    hidden: 'input',
    text: 'el-input',
    textarea: 'el-input',
    number: 'el-input',
    password: 'el-input',
    file: 'Upload',
    date: 'el-date-picker',
    datetime: 'el-date-picker',
    time: 'el-time-select',
    checkbox: 'Checkbox',
    radio: 'Checkbox',
    select: 'RemoteSelect',
    'select-multiple': 'RemoteSelect',
    dictionary: 'DictionariesPicker',
    region: 'CascaderPicker',
    studyHistory: 'EditStudyHistory',
    workHistory: 'EditWorkHistory',
    signature: 'EditSignature',
};
export function getComponentName(cur) {
    const { type, properties } = cur;
    if (type === 'dictionary') {
        if (properties.bitwise) {
            return 'CheckboxGroupAndOr';
        }
        return 'DictionariesPicker';
    }
    return typeComponentMap[type];
}

export function buildProps(field) {
    const { properties, type } = field;
    if (!properties) return {};
    const res = properties.uiProps || {};
    if (/hidden|text|textarea|number|password|date|datetime|time|checkbox|radio/.test(type)) {
        res.type = type;
    }
    // 添加平台特有属性
    if (type === 'date') {
        res.valueFormat = 'yyyy-MM-dd';
    }
    if (type === 'region') {
        res.apiClass = Api.Rs.Region;
    }
    return [
        // 通用
        'placeholder',
        'tips',
        'required',
        'readonly',
        { disabled: 'readonly' },
        'disabled',
        // textarea
        'minRows',
        'maxRows',
        // checkbox|radio|select|select-multiple
        { data: 'options' },
        'extraOptions',
        'enableOther',
        { props: 'optionsProps' },
        // checkbox|select-multiple
        // { bitwise: 'bitwiseValue' },
        'bitwise',
        // date|datetime|time
        { format: 'dateFormat' },
        // file
        'action',
        'accept',
        'demoImage',
        'multiple',
        { limit: 'maxFiles' },
        'checkType',
        // workHistory|studyHistory
        'maxCount',
        // studyHistory
        'degreeDictionary',
    ].reduce((pre, cur) => {
        let key = cur;
        let targetKey = cur;
        if (isObject(cur)) [[key, targetKey]] = Object.entries(cur);
        let val = properties[targetKey];
        // 修正值
        if (key === 'format' && !!val) {
            val = val.replace(/[YD]/g, m => m.toLocaleLowerCase());
        }
        if (key === 'action' && !!val) {
            val = val.replace(/^\/comm/, '');
        }
        if (hasOwn(properties, targetKey)) pre[key] = val;
        return pre;
    }, res);
}

export function buildValue(field, valueData = {}) {
    const { properties, type, name } = field;
    let value = valueData[name];

    if (!isDef(value)) {
        value = properties.value;
    }
    if (/file|studyHistory|workHistory/.test(type)) {
        if (type === 'file' && isString(value)) {
            const splitStr = GlobalVar.fileLibraryPath;
            value = value.split(',').reduce((pre, cur) => {
                if (cur) {
                    pre.push({
                        address: cur,
                        name: cur.replace(splitStr, ''),
                    });
                }
                return pre;
            }, []);
        }
        if (!isArray(value) && !value) value = [];
    }
    return value || '';
}

export function buildValidate(field) {
    const rules = [];
    const { label, properties } = field;
    const { required, validates } = properties;
    // if (required) rules.push({ required: true, message: `${label}不能为空` });
    if (required) {
        rules.push({
            validator: Valid.strictRequired,
            key: required === true ? 'id' : required,
            message: `${label}不能为空`,
        });
    }
    if (validates) {
        validates.forEach(item => {
            const { type, method, message } = item;
            const validFn = Valid[type];
            if (validFn) {
                rules.push({
                    validator: validFn,
                    regExpStr: method,
                    message,
                });
            } else if (type === 'RegExp' && method) {
                rules.push({
                    regexp: method,
                    message,
                });
            }
        });
    }
    return rules.length ? rules : null;
}
